const mediaItems = [
  {
    title: '《长安十二时辰》终极预告',
    desc: '雷佳音、易烊千玺领衔，4K修复版震撼来袭',
    duration: '02:35',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20trailer%20scene%20ancient%20Chinese%20city%20at%20night%20with%20warm%20lanterns%20dramatic%20lighting%20epic%20composition%20dark%20atmosphere%20film%20grain%20texture%20no%20text&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    title: '《流浪地球3》幕后制作特辑',
    desc: '独家探秘中国科幻电影工业化之路',
    duration: '05:18',
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20film%20production%20behind%20the%20scenes%20abstract%20visual%20futuristic%20set%20design%20warm%20lighting%20dark%20atmosphere%20cinematic%20style%20no%20text&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    title: '《这！就是街舞7》高光集锦',
    desc: '本季最炸裂的十个舞台，一次看个够',
    duration: '08:42',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20dance%20stage%20performance%20highlight%20abstract%20visual%20vibrant%20spotlights%20motion%20blur%20dark%20background%20energetic%20cinematic%20style%20no%20text&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="relative py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">精彩预告</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">最新预告片、幕后花絮与精彩集锦，先睹为快</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group bg-background-200/50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/20 transition-colors cursor-pointer">
              <div className="relative h-48 md:h-52 overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-950/60 backdrop-blur-sm text-primary-400 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 rounded bg-background-950/70 text-foreground-300 text-xs backdrop-blur-sm">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-foreground-100 font-semibold text-sm md:text-base mb-1">{item.title}</h3>
                <p className="text-foreground-500 text-xs">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}